module.exports = __webpack_public_path__ + "img/logo.d7cffd46.png";